//logos
import wellezyLogo from '../assets/logos/wellezy.png';
import LatamLogo from '../assets/logos/LatamLogo.png';
import VivaLogo from '../assets/logos/VivaLogo.png';
import AviancaLogo from '../assets/logos/AviancaLogo.png';
import Alert from '../assets/logos/wellezy.png'; /* revisar */
import LogoBlue from '../assets/logos/wellezy.png'; /* revisar */
import AppStoreLogo from '../assets/logos/AppStoreLogo.png';
import GooglePlayLogo from '../assets/logos/GooglePlayLogo.png';
import IATALogo from '../assets/logos/IATALogo.png';
import PaypalLogo from '../assets/logos/PaypalLogo.png';
import VisaLogo from '../assets/logos/VisaLogo.png';
import MasterCardLogo from '../assets/logos/MasterCardLogo.png';

//iconos
import iconLuggage from '../assets/icons/ChooseLuggage.png';
import iconLuggageBlue from '../assets/icons/ChooseLuggageBlue.png';
import iconAirplane from '../assets/icons/Airplane.png';

//icons svg
import { ReactComponent as IconBagBig } from '../assets/iconsSVG/iconBagBigActive.svg';
import { ReactComponent as IconBagMedium } from '../assets/iconsSVG/iconBagMediumActive.svg';
import { ReactComponent as IconBagSmall } from '../assets/iconsSVG/iconBagSmallActive.svg';
import { ReactComponent as IconAddItem } from '../assets/iconsSVG/IconAddItem.svg';
import { ReactComponent as IconAmbulance } from '../assets/iconsSVG/IconAmbulance.svg';
import { ReactComponent as IconBag } from '../assets/iconsSVG/IconBag.svg';
import { ReactComponent as IconBeautiful } from '../assets/iconsSVG/IconBeautiful.svg';
import { ReactComponent as IconBeautySalon } from '../assets/iconsSVG/IconBeautySalon.svg';
import { ReactComponent as IconBus } from '../assets/iconsSVG/IconBus.svg';
import { ReactComponent as IconCalendar } from '../assets/iconsSVG/IconCalendar.svg';
import { ReactComponent as IconCall } from '../assets/iconsSVG/IconCall.svg';
import { ReactComponent as IconCallCenter } from '../assets/iconsSVG/IconCallCenter.svg';
import { ReactComponent as IconCartBuy } from '../assets/iconsSVG/IconCartBuy.svg';
import { ReactComponent as IconChat } from '../assets/iconsSVG/IconChat.svg';
import { ReactComponent as IconCheckBuy } from '../assets/iconsSVG/IconCheckBuy.svg';
import { ReactComponent as IconCheckSucces } from '../assets/iconsSVG/IconCheckSucces.svg';
import { ReactComponent as IconDealDone } from '../assets/iconsSVG/IconDealDone.svg';
import { ReactComponent as IconDoctor } from '../assets/iconsSVG/IconDoctor.svg';
import { ReactComponent as IconFilters } from '../assets/iconsSVG/IconFilters.svg';
import { ReactComponent as IconFood } from '../assets/iconsSVG/IconFood.svg';
import { ReactComponent as IconFrecuentQuestions } from '../assets/iconsSVG/IconFrequentQuestions.svg';
import { ReactComponent as IconHospital } from '../assets/iconsSVG/IconHospital.svg';
import { ReactComponent as IconHotel } from '../assets/iconsSVG/IconHotel.svg';
import { ReactComponent as IconListItem } from '../assets/iconsSVG/IconListItems.svg';
import { ReactComponent as IconListMedicaments } from '../assets/iconsSVG/iconListMedicaments.svg';
import { ReactComponent as IconMap } from '../assets/iconsSVG/IconMap.svg';
import { ReactComponent as IconMedicaments } from '../assets/iconsSVG/IconMedicaments.svg';
import { ReactComponent as IconMegaPhone } from '../assets/iconsSVG/IconMegaPhone.svg';
import { ReactComponent as IconNotice } from '../assets/iconsSVG/IconNotice.svg';
import { ReactComponent as IconNurse } from '../assets/iconsSVG/IconNurse.svg';
import { ReactComponent as IconPeoples } from '../assets/iconsSVG/IconPeoples.svg';
import { ReactComponent as IconPhoneRing } from '../assets/iconsSVG/IconPhoneRing.svg';
import { ReactComponent as IconPinMap } from '../assets/iconsSVG/IconPinMap.svg';
import { ReactComponent as IconPinMapBlank } from '../assets/iconsSVG/IconPinMapBlank.svg';
import { ReactComponent as IconPlane } from '../assets/iconsSVG/IconPlane.svg';
import { ReactComponent as IconPlane2 } from '../assets/iconsSVG/IconPlane2.svg';
import { ReactComponent as IconPrize } from '../assets/iconsSVG/IconPrize.svg';
import { ReactComponent as IconProfile } from '../assets/iconsSVG/IconProfile.svg';
import { ReactComponent as IconQuestions } from '../assets/iconsSVG/IconQuestions.svg';
import { ReactComponent as IconReloj } from '../assets/iconsSVG/IconReloj.svg';
import { ReactComponent as IconRentaCar } from '../assets/iconsSVG/IconRentaCar.svg';
import { ReactComponent as IconRestHouse } from '../assets/iconsSVG/IconRestHouse.svg';
import { ReactComponent as IconRestRoom } from '../assets/iconsSVG/IconRestRoom.svg';
import { ReactComponent as IconSearch } from '../assets/iconsSVG/IconSearch.svg';
import { ReactComponent as IconSecureTravel } from '../assets/iconsSVG/IconSecureTravel.svg';
import { ReactComponent as IconSell } from '../assets/iconsSVG/IconSell.svg';
import { ReactComponent as IconTaxi } from '../assets/iconsSVG/IconTaxi.svg';
import { ReactComponent as IconTravel } from '../assets/iconsSVG/IconTravel.svg';
import { ReactComponent as IconWhatsapp } from '../assets/iconsSVG/IconWhatsapp.svg';
import { ReactComponent as IconStar } from '../assets/iconsSVG/IconStar.svg';
import { ReactComponent as IconPencilOutLine} from '../assets/iconsSVG/IconPencilOutLine.svg';
import { ReactComponent as IconAlertOutLine} from '../assets/iconsSVG/IconAlertOutLine.svg';
import { ReactComponent as IconPlusCircleOutLine} from '../assets/iconsSVG/IconPlusCircleOutLine.svg';
import { ReactComponent as IconWalletOutLine} from '../assets/iconsSVG/IconWalletOutLine.svg';
import { ReactComponent as IconHeartOutLine} from '../assets/iconsSVG/IconHeartOutLine.svg';
import { ReactComponent as IconCoupon} from '../assets/iconsSVG/IconCoupon.svg';
import { ReactComponent as IconCalendarOutLine2} from '../assets/iconsSVG/IconCalendarOutLine2.svg';
import { ReactComponent as IconOrders} from '../assets/iconsSVG/IconOrders.svg';
import { ReactComponent as IconTeleconsultationsOutLine} from '../assets/iconsSVG/IconTeleconsultationsOutLine.svg';
import { ReactComponent as IconDatafono} from '../assets/iconsSVG/IconDatafono.svg';
import { ReactComponent as IconInsurance} from '../assets/iconsSVG/IconInsurance.svg';
import { ReactComponent as IconShopSuppliesAndMore} from '../assets/iconsSVG/IconShopSuppliesAndMore.svg';
import { ReactComponent as IconUserCircleOutLine} from '../assets/iconsSVG/IconUserCircleOutLine.svg';
import { ReactComponent as IconTrashOutLine} from '../assets/iconsSVG/IconTrashOutLine.svg';
import { ReactComponent as IconCloseCircleOutLine} from '../assets/iconsSVG/IconCloseCircleOutLine.svg';
import { ReactComponent as IconEyeOn} from '../assets/iconsSVG/IconEyeOn.svg';
import { ReactComponent as IconEyeOff} from '../assets/iconsSVG/IconEyeOff.svg';
import { ReactComponent as IconPaperList} from '../assets/iconsSVG/IconPaperList.svg';
import { ReactComponent as IconArrowDown} from '../assets/iconsSVG/IconArrowDown.svg';

//pictures
import BannerTours from '../assets/pictures/BannerTours.png'
export const global = {
    colors: {
        primary: {
            blue: '#3b82f6',
            white: '#FFFFFF',
            gary: '#94a3b8',
            gray_light: '#f5f5f5',
            gary_dark: '#64748b',
            black: '#000000',
        }
    },
    fonts: {},

    img: {
        icons: {
            iconLuggage,
            iconLuggageBlue,
            iconAirplane,
        },

        iconsSVG: {
            IconBagBig,
            IconBagMedium,
            IconBagSmall,
            IconAddItem,
            IconAmbulance,
            IconBag,
            IconBeautiful,
            IconBeautySalon,
            IconBus,
            IconCalendar,
            IconCall,
            IconCallCenter,
            IconCartBuy,
            IconChat,
            IconCheckBuy,
            IconCheckSucces,
            IconDealDone,
            IconDoctor,
            IconFilters,
            IconFood,
            IconFrecuentQuestions,
            IconHospital,
            IconHotel,
            IconListItem,
            IconListMedicaments,
            IconMap,
            IconMedicaments,
            IconMegaPhone,
            IconNotice,
            IconNurse,
            IconPeoples,
            IconPhoneRing,
            IconPinMap,
            IconPinMapBlank,
            IconPlane,
            IconPlane2,
            IconPrize,
            IconProfile,
            IconQuestions,
            IconReloj,
            IconRentaCar,
            IconRestHouse,
            IconRestRoom,
            IconSearch,
            IconSecureTravel,
            IconSell,
            IconTaxi,
            IconTravel,
            IconWhatsapp,
            IconStar,
            IconPaperList,
            IconArrowDown,
            IconPencilOutLine,
            IconAlertOutLine,
            IconPlusCircleOutLine,
            IconWalletOutLine,
            IconHeartOutLine,
            IconCoupon,
            IconCalendarOutLine2,
            IconOrders,
            IconTeleconsultationsOutLine,
            IconDatafono,
            IconInsurance,
            IconShopSuppliesAndMore,
            IconUserCircleOutLine,
            IconTrashOutLine,
            IconCloseCircleOutLine,
            IconEyeOn,
            IconEyeOff,
        },
        images: {},
        logos: {
            wellezyLogo,
            LatamLogo,
            VivaLogo,
            AviancaLogo,
            Alert,
            LogoBlue,
            AppStoreLogo,
            GooglePlayLogo,
            IATALogo,
            PaypalLogo,
            VisaLogo,
            MasterCardLogo
        },
        pictures: {
            iconAirplane,
            BannerTours,
        },
    },
};

